// extracted by mini-css-extract-plugin
module.exports = {"poster":"Services_poster__2PlRC","box":"Services_box__1LUM_","box1":"Services_box1__13gE_","animate":"Services_animate__LWzjR"};